import * as React from 'react';

import { Skeleton } from './components/ui/skeleton.js';

export function DimeSkeleton({ ...props }: Readonly<React.ComponentProps<typeof Skeleton>>) {
  return <Skeleton {...props} />;
}
